import React from 'react';
import { Container, Heading, Text, Button, Flex, Card } from '@radix-ui/themes';
import { useNavigate } from 'react-router-dom';

const SubscriptionCancel = () => {
  const navigate = useNavigate();

  return (
    <Container size="3">
      <Flex direction="column" gap="6" align="center" justify="center" style={{ minHeight: '60vh' }}>
        <Card>
          <Flex direction="column" gap="4" p="4">
            <Heading size="6" color="red">Cancel Subscription</Heading>
            <Text size="4">Are you sure you want to cancel your subscription?</Text>
            <Text size="3" color="gray">Your access will continue until the end of your current billing period.</Text>
            <Flex gap="3" mt="4">
              <Button size="3" color="red" onClick={() => navigate('/payments')}>
                Yes, Cancel Subscription
              </Button>
              <Button size="3" variant="soft" onClick={() => navigate('/dashboard')}>
                No, Keep Subscription
              </Button>
            </Flex>
          </Flex>
        </Card>
      </Flex>
    </Container>
  );
};

export default SubscriptionCancel; 